import { render, staticRenderFns } from "./dustbinIcon.vue?vue&type=template&id=3fc693d5&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc693d5')) {
      api.createRecord('3fc693d5', component.options)
    } else {
      api.rerender('3fc693d5', component.options)
    }
    module.hot.accept("./dustbinIcon.vue?vue&type=template&id=3fc693d5&functional=true&", function () {
      api.rerender('3fc693d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/listView/table/icons/dustbinIcon.vue"
export default component.exports